import React from 'react';
import { SearchIconContainer, SearchInputLoadingIcon, SearchInputSearchIcon } from './style';
import { useComponentTheme } from '../../../utils/hooks';
import { SEARCH_ICON_CLASS_PREFIX } from './constants';
import { useSearchIconClassName } from './utils';
import { searchIconTheme } from './theme';
export var SearchIcon = function SearchIcon(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      disabled = _ref.disabled;
  var theme = useComponentTheme(SEARCH_ICON_CLASS_PREFIX, searchIconTheme);
  var classOverride = useSearchIconClassName(SEARCH_ICON_CLASS_PREFIX, className, disabled);
  return isLoading ? React.createElement(SearchIconContainer, {
    className: classOverride.BeforeIconContainer,
    theme: theme
  }, React.createElement(SearchInputLoadingIcon, {
    className: classOverride.BeforeIcon,
    theme: theme
  })) : React.createElement(SearchIconContainer, {
    className: classOverride.BeforeIconContainer,
    theme: theme
  }, React.createElement(SearchInputSearchIcon, {
    className: classOverride.BeforeIcon,
    theme: theme
  }));
};